import { Adapter, SendToOptions } from './adapter';
import { getScript } from '../utils/http';

// TODO: test
export default class AdapterImpl implements Adapter {
  public async init(): Promise<void> {
    if (typeof window.msdkCall !== 'function') {
      await getScript('https://tiem-cdn.qq.com/slugteam/components/share/v2.0/msdkv5Helper.js');
    }
  }
  public async sendTo(_config: any, { channelID, ...shareConfig }: SendToOptions): Promise<void> {
    const { title, desc, url, imgUrl } = shareConfig;
    let msdkShareData: any;
    switch (channelID) {
      case 'wxt': {
        msdkShareData = JSON.stringify({
          channel: 'WeChat',
          MsdkMethod: 'shareWebView',
          actionReport: 'MSG_INVITE',
          imagePath: imgUrl,
          link: url,
          messageExt: 'messageExt',
          tailLogo: 'WECHAT_SNS_JUMP_APP',
          thumbPath: imgUrl,
          type: 10001,
          user: '',
          title,
          desc,
        });
        break;
      }
      case 'wxf': {
        msdkShareData = JSON.stringify({
          channel: 'WeChat',
          MsdkMethod: 'sendMsgWebView',
          actionReport: 'MSG_INVITE',
          imagePath: imgUrl,
          link: url,
          messageExt: 'messageExt',
          tailLogo: 'WECHAT_SNS_JUMP_APP',
          thumbPath: imgUrl,
          type: 10001,
          user: '',
          title,
          desc,
        });
        break;
      }
      case 'qqf': {
        msdkShareData = JSON.stringify({
          channel: 'QQ',
          MsdkMethod: 'sendMsgWebView',
          actionReport: 'MSG_INVITE',
          imagePath: imgUrl,
          link: url,
          messageExt: 'messageExt',
          tailLogo: 'WECHAT_SNS_JUMP_APP',
          thumbPath: imgUrl,
          type: 10001,
          user: '',
          title,
          desc,
        });
        break;
      }
      case 'qqz': {
        msdkShareData = JSON.stringify({
          channel: 'QQ',
          MsdkMethod: 'shareWebView',
          actionReport: 'MSG_INVITE',
          imagePath: imgUrl,
          link: url,
          messageExt: 'messageExt',
          tailLogo: 'WECHAT_SNS_JUMP_APP',
          thumbPath: imgUrl,
          type: 10001,
          user: '',
          title,
          desc,
        });
        break;
      }
    }

    window.msdkCall(msdkShareData);
  }
};
